import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageTitle, PageActions, PageSubtitle } from "../Layouts/components/PageTitleContainer";
import { KindMovementRule } from "types/locationManagement/kindMovementRule";
import { RevivnDatabaseDataGrid } from "components/DataGrid/RevivnDatabaseDataGrid";
import { linkColDef } from "components/DataGrid/columnDefs/linkColDef";
import { actionColDef } from "components/DataGrid/columnDefs/actionColDef";
import { GridValueGetterParams } from "@mui/x-data-grid-pro";
import { dateColDef } from "components/DataGrid/columnDefs/dateColDef";

const KindMovementRuleList: React.FC = () => {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Admin" }, { label: "Kind Movements", path: "/kind-movements" }]} />
      <PageTitle>Kind Movements</PageTitle>
      <PageSubtitle>
        A location kind cannot be moved unless a rule lists the destination kind. A kind with no rule cannot be scanned
        or moved.
      </PageSubtitle>
      <PageActions>
        <Button variant="contained" color="primary" component={Link} to="/kind-movements/new">
          Create Kind Movement
        </Button>
      </PageActions>
      <RevivnDatabaseDataGrid
        url="/location_management/kind_movement_rules"
        syncStateWithSearchParams
        columns={[
          { field: "id", headerName: "ID", width: 90, filterable: false },
          {
            field: "fromLocationKind.name",
            headerName: "From Location Kind",
            width: 220,
            filterable: false,
            valueGetter: (params: GridValueGetterParams<KindMovementRule>) => params.row.fromLocationKind?.name,
            ...linkColDef<KindMovementRule>(({ row }) => `/location-kinds/${row.fromLocationKind?.id}/edit`),
          },
          {
            field: "toLocationKind.name",
            headerName: "To Location Kind",
            width: 220,
            filterable: false,
            valueGetter: (params: GridValueGetterParams<KindMovementRule>) => params.row.toLocationKind?.name,
            ...linkColDef<KindMovementRule>(({ row }) => `/location-kinds/${row.toLocationKind?.id}/edit`),
          },
          {
            field: "createdAt",
            headerName: "Created At",
            width: 200,
            filterable: false,
            ...dateColDef,
          },
          {
            field: "edit",
            headerName: "Edit",
            width: 120,
            sortable: false,
            filterable: false,
            valueGetter: (_params: GridValueGetterParams) => "Edit",
            ...linkColDef<KindMovementRule>(({ row }) => `/kind-movements/${row.id}/edit`),
          },
          {
            field: "delete",
            headerName: "Delete",
            width: 120,
            sortable: false,
            filterable: false,
            ...actionColDef<KindMovementRule>(
              ({ row }) => ({ method: "delete", action: `/kind-movements/${row.id}/delete` }),
              <Button
                type="submit"
                variant="outlined"
                color="error"
                size="small"
                onClick={(e) => {
                  if (!confirm("Are you sure you want to delete this kind movement?")) {
                    e.preventDefault();
                  }
                }}
              >
                Delete
              </Button>,
            ),
          },
        ]}
        pageSize={25}
      />
    </FullPagePaperLayout>
  );
};

export default KindMovementRuleList;
